import { Box, type BoxProps } from '../Box'
import { type ListProps } from '../List/List'
import { Tab } from '../Tab'
import { toggleGroupCss, toggleGroupItemCss } from './ToggleGroup.css'

export const ToggleGroup = ({
  children,
  ...props
}: Omit<BoxProps, 'as' | 'className'>) => {
  return (
    <Box
      as="ul"
      className={toggleGroupCss}
      role="group"
      tabIndex={0}
      {...props}
    >
      {children}
    </Box>
  )
}

export function ToggleGroupItem({
  children,
  isActive = false,
  disabled,
  ...props
}: Omit<ListProps, 'unstyled'> & { isActive?: boolean }) {
  return (
    <Box as="li" className={toggleGroupItemCss} {...props}>
      <Tab
        isActive={isActive}
        tabIndex={isActive ? 0 : -1}
        role="radio"
        disabled={disabled}
      >
        {children}
      </Tab>
    </Box>
  )
}
